export default class KnownInternalNames {
    static Networks = class {
        public static readonly ArbitrumSepolia: string = "eip155:421614";

        public static readonly EthereumSepolia: string = "eip155:11155111";

        public static readonly BaseSepolia: string = "eip155:84532";

        public static readonly MonadTestnet: string = "eip155:10143";

        public static readonly AztecDevnet: string = "aztec:aztec-devnet"

        public static readonly AztecTestnet: string = "aztec:4138294185"

        public static readonly SolanaDevnet: string = "solana:devnet";

        public static readonly TronMainnet: string = "TRON_MAINNET"

        public static readonly TronNile: string = "tron:3448148188"

        public static readonly CronosMainnet: string = "CRONOS_MAINNET";

        public static readonly OsmosisMainnet: string = "OSMOSIS_MAINNET";

        public static readonly ArbitrumMainnet: string = "ARBITRUM_MAINNET";

        public static readonly ArbitrumNova: string = "ARBITRUMNOVA_MAINNET";

        public static readonly ArbitrumRinkeby: string = "ARBITRUM_RINKEBY";

        public static readonly ArbitrumGoerli: string = "ARBITRUM_GOERLI";

        public static readonly ModMainnet: string = "MODE_MAINNET";

        public static readonly OptimismMainnet: string = "OPTIMISM_MAINNET";

        public static readonly OptimismGoerli: string = "OPTIMISM_GOERLI";

        public static readonly OptimismKovan: string = "OPTIMISM_KOVAN";

        public static readonly RoninMainnet: string = "RONIN_MAINNET";

        public static readonly BobaMainnet: string = "BOBA_MAINNET";

        public static readonly BobaRinkeby: string = "BOBA_RINKEBY";

        public static readonly ZksyncMainnet: string = "ZKSYNC_MAINNET";

        public static readonly ZksyncEraMainnet: string = "ZKSYNCERA_MAINNET";

        public static readonly ZkspaceMainnet: string = "ZKSPACE_MAINNET";

        public static readonly ZksyncRinkeby: string = "ZKSYNC_RINKEBY";

        public static readonly EthereumRinkeby: string = "ETHEREUM_RINKEBY";

        public static readonly EthereumMainnet: string = "eip155:1";

        public static readonly EthereumGoerli: string = "ETHEREUM_GOERLI";

        public static readonly PolygonMainnet: string = "POLYGON_MAINNET";

        public static readonly LoopringMainnet: string = "LOOPRING_MAINNET";

        public static readonly LoopringGoerli: string = "LOOPRING_GOERLI";

        public static readonly LoopringSepolia: string = "LOOPRING_SEPOLIA";

        public static readonly MoonbeamMainnet: string = "MOONBEAM_MAINNET";

        public static readonly StarkNetGoerli: string = "STARKNET_GOERLI";

        public static readonly StarkNetMainnet: string = "STARKNET_MAINNET";

        public static readonly StarkNetSepolia: string = "starknet:SN_SEPOLIA";

        public static readonly ImmutableZkEVM: string = "IMMUTABLEZK_MAINNET";

        public static readonly ImmutableZkTestnet: string = "IMMUTABLEZK_TESTNET";

        public static readonly AstarMainnet: string = "ASTAR_MAINNET";

        public static readonly NahmiiMainnet: string = "NAHMII_MAINNET";

        public static readonly RhinoFiMainnet: string = "RHINOFI_MAINNET";

        public static readonly DydxMainnet: string = "DYDX_MAINNET";

        public static readonly DydxGoerli: string = "DYDX_GOERLI";

        public static readonly BNBChainMainnet: string = "BSC_MAINNET";

        public static readonly SolanaMainnet: string = "SOLANA_MAINNET";

        public static readonly SolanaTestnet: string = "SOLANA_TESTNET";

        public static readonly SoonMainnet: string = "SOON_MAINNET";

        public static readonly SoonTestnet: string = "SOON_TESTNET";

        public static readonly SorareStage: string = "SORARE_MAINNET";

        public static readonly KCCMainnet: string = "KCC_MAINNET";

        public static readonly OKCMainnet: string = "OKC_MAINNET";

        public static readonly PolygonZkMainnet: string = "POLYGONZK_MAINNET";

        public static readonly LineaMainnet: string = "LINEA_MAINNET";

        public static readonly BaseMainnet: string = "BASE_MAINNET";

        public static readonly BaseTestnet: string = "BASE_TESTNET";

        public static readonly AvalancheMainnet: string = "AVAX_MAINNET";

        public static readonly PGNMainnet: string = "PGN_MAINNET";

        public static readonly PGNTestnet: string = "PGN_TESTNET";

        public static readonly MantleMainnet: string = "MANTLE_MAINNET";

        public static readonly ZoraMainnet: string = "ZORA_MAINNET";

        public static readonly RolluxMainnet: string = "ROLLUX_MAINNET";

        public static readonly OpBNBMainnet: string = "OPBNB_MAINNET";

        public static readonly MantaMainnet: string = "MANTA_MAINNET";

        public static readonly ScrollMainnet: string = "SCROLL_MAINNET";

        public static readonly TONMainnet: string = "TON_MAINNET";

        public static readonly TONTestnet: string = "TON_TESTNET";

        public static readonly BrineMainnet: string = "BRINE_MAINNET";

        public static readonly BlastSepolia: string = "BLAST_SEPOLIA";

        public static readonly BlastMainnet: string = "BLAST_MAINNET";

        public static readonly ParadexTestnet: string = "PARADEX_TESTNET"

        public static readonly ParadexMainnet: string = "PARADEX_MAINNET"

        public static readonly FuelMainnet: string = "FUEL_MAINNET"

        public static readonly FuelTestnet: string = "FUEL_TESTNET"

        public static readonly FuelDevnet: string = "FUEL_DEVNET"

        public static readonly EclipseTestnet: string = "ECLIPSE_TESTNET"

        public static readonly EclipseMainnet: string = "ECLIPSE_MAINNET"

        public static readonly SophonMainnet: string = "SOPHON_MAINNET"

        public static readonly SophonSepolia: string = "SOPHON_SEPOLIA"

        public static readonly RedStoneMainnet: string = "REDSTONE_MAINNET"

        public static readonly SoneiumMainnet: string = "SONEIUM_MAINNET"

        public static readonly RariMainnet: string = "RARI_MAINNET";

        public static readonly LightlinkMainnet: string = "LIGHTLINK_MAINNET";

        public static readonly ZetachainMainnet: string = "ZETACHAIN_MAINNET";

        public static readonly AvaxMainnet: string = "AVAX_TESTNET";

        public static readonly XaiMainnet: string = "XAI_MAINNET";

        public static readonly UnichainMainnet: string = "UNICHAIN_MAINNET";

        public static readonly XlayerMainnet: string = "XLAYER_MAINNET";

        public static readonly FraxtalMainnet: string = "FRAXTAL_MAINNET";

        public static readonly WorldchainMainnet: string = "WORLDCHAIN_MAINNET";

        public static readonly AbstractMainnet: string = "ABSTRACT_MAINNET";

        public static readonly CeloMainnet: string = "CELO_MAINNET";

        public static readonly KromaMainnet: string = "KROMA_MAINNET";

        public static readonly ShapeMainnet: string = "SHAPE_MAINNET";

        public static readonly GnosisMainnet: string = "GNOSIS_MAINNET";

        public static readonly TaikoMainnet: string = "TAIKO_MAINNET";

        public static readonly InkMainnet: string = "INK_MAINNET";

        public static readonly MintMainnet: string = "MINT_MAINNET";

        public static readonly Ancient8Mainnet: string = "ANCIENT8_MAINNET";

        public static readonly BobMainnet: string = "BOB_MAINNET";

        public static readonly FuseMainnet: string = "FUSE_MAINNET";

        public static readonly SonicMainnet: string = "SONIC_MAINNET";

        public static readonly ZeroMainnet: string = "ZERO_MAINNET";

        public static readonly ZircuitMainnet: string = "ZIRCUIT_MAINNET";

        public static readonly SuperseedMainnet: string = "SUPERSEED_MAINNET";

        public static readonly LiskMainnet: string = "LISK_MAINNET";

        public static readonly MorphMainnet: string = "MORPH_MAINNET";

        public static readonly SeiMainnet: string = "SEI_MAINNET";

        public static readonly GravityMainnet: string = "GRAVITY_MAINNET";

        public static readonly BitcoinMainnet: string = "BITCOIN_MAINNET"

        public static readonly BitcoinTestnet: string = "BITCOIN_TESTNET"

        public static readonly HyperliquidMainnet: string = "HYPERLIQUID_MAINNET"

        public static readonly HyperliquidTestnet: string = "HYPERLIQUID_TESTNET"

        public static readonly MonadMainnet: string = "MONAD_MAINNET"

    }

    static Currencies = class {
        public static readonly USDT: string = "USDT";
        public static readonly ETH: string = "ETH";
        public static readonly USDC: string = "USDC";
        public static readonly USDCe: string = "USDC.e";
        public static readonly USDCE: string = "USDC.E";
    }

}